import React from "react";
import "../../styles/Home.scss";
import aplicLogo from "../../components/assets/aplic-logo-nb.png";

const HomeRight = () => {
  return (
    <section className="home relative">
      <div className="home-right">
        <img src={aplicLogo} alt="APLIC 2027 Logo" className="aplic-logo" />

        <h2 className="location">Manila, Philippines</h2>

        <p className="description">
          The APLIC 2027 congress is aimed at promoting professionalism of 
          financial services advisory in the region.
        </p>

        <button className="register-btn" onClick={() => window.open("https://aplic2027.gottit.io/", "_blank")}><span className="btn-text">Register Now</span></button>
      </div>
    </section>
  );
};

export default HomeRight;
